import type { BindingContext } from '../../utils/bindingContext';
import type { SiteContract } from '@tamtamy/paperbits-common/src/multisite/siteContract';

export function playerCustomizer(html?: string, captionLang?: string, bindingContext?: BindingContext) {
    const site: SiteContract | undefined = bindingContext?.site;
    return html?.replace(
        /(<iframe[^>]*src=["'])([^'"]+)(["'][^>]*>)/,
        `$1$2&analyticsEnabled=true&captionLang=${(captionLang || site?.language || 'en')}$3`
    );
}